<template>
    <div class="text-block">
        <div class="pull-left">
            <a data-fancybox="gallery" data-type="image" :href="`/img/gallery/${pic}`">
                <div class="thumb mr-1 mb-1">
                    <v-img :src="`/img/gallery/${pic}`" width=100% ></v-img>              
                </div>
            </a>
        </div>
        <div class="block-text" v-html="text"></div>
    </div>
</template>

<script>
    export default {
       props: ['pic', 'text']
}
</script>

<style>
    .block-text {
        margin: 0 0 20px;
        font-size: 14px;
        font-family: 'Oswald', sans-serif!important;
    }
    .text-block .thumb {
        margin: 5px 10px 10px 0!important;
        border-radius: 5px; 
		padding: 2px; 
		width: 150px!important; 
        height: 150px!important; 	
        overflow: hidden;
        background-color: #020305;
    }

</style>
